





















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {ArticleParams} from "../../../params";
import EnumSelector from "../../../../../shared/components/EnumSelector/index.vue";
import PostOfficeSelector from "../../../../../shared/components/PostOfficeSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {ArticleStore} from "@/modules/article/store";
import debounce from "lodash/debounce";
@Component({
    name: "ArticleSearch",
    components: {PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    params = new ArticleParams();
    CommonStatus = CommonStatus;

    @Watch("params", { deep: true })
    onchangeParams(val: any) {
        this.handleChangeParams(val);
    }

    handleChangeParams = debounce((val: any) => {
        const params = {...val, page: 1};
        ArticleStore.updateParams(params);
        ArticleStore.listArticles(params);
    }, 500)
}
